export interface ScriptFlourishProps {
  className?: string;
}

/**
 * Filete dorado curvo con final en voluta: subraya la segunda línea del claim
 * manuscrito "Despierta tu poder. / Vive tu propósito.".
 * Se estira al ancho del claim sin engordar el trazo.
 */
export function ScriptFlourish({ className }: ScriptFlourishProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 240 22"
      preserveAspectRatio="none"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.1}
      strokeLinecap="round"
      vectorEffect="non-scaling-stroke"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M2 15C46 5 118 2 196 8" />
      <path d="M196 8c9 .7 14 2.6 14 5.4 0 2.3-2.6 3.6-5 2.8-2.6-.9-3-4.2-.6-6 2.3-1.8 6.9-2.6 13.6-2.2" />
    </svg>
  );
}
